import React from 'react';
import { SelectOption } from 'global';
import { useFormContext, useWatch } from 'react-hook-form';
import { FinanceCommonFields } from './FinanceCommonFields';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { FinanceExistingProgramFields } from './FinanceExistingProgramFields';
import { CreateProposalFinanceExistingOptions, FinanceFormValues } from '../types';

export const FinanceDetails = ({
  netInvoiceAmount,
  isFPOptionsLoading,
  financeProgramOptions,
  onFetchFinanceProgram,
}: {
  netInvoiceAmount: number;
  isFPOptionsLoading: boolean;
  financeProgramOptions: SelectOption[];
  onFetchFinanceProgram: (programId: string) => Promise<Partial<FinanceFormValues['financeQuote']>>;
}) => {
  const { control } = useFormContext<FinanceFormValues>();

  const [createProposalWithExistingProgram, program] = useWatch({
    control,
    name: ['financeQuote.createProposalWithExistingProgram', 'financeQuote.program'],
  });

  const isShowExistingProgramFields = createProposalWithExistingProgram === CreateProposalFinanceExistingOptions.Yes;
  const isShowCommonProgramFields = Boolean(program) || !isShowExistingProgramFields;

  return (
    <>
      <RenderWithCondition condition={isShowExistingProgramFields}>
        <FinanceExistingProgramFields
          isFPOptionsLoading={isFPOptionsLoading}
          onFetchFinanceProgram={onFetchFinanceProgram}
          financeProgramOptions={financeProgramOptions}
        />
      </RenderWithCondition>

      <RenderWithCondition condition={isShowCommonProgramFields}>
        <FinanceCommonFields netInvoiceAmount={netInvoiceAmount} />
      </RenderWithCondition>
    </>
  );
};
